import React from "react";
import { jurisdictionInfo } from "./shared/Constants";
import Upgrade from "./Upgrade";

function PennsylvaniaUpgrade() {
  return <Upgrade jurisdictionInfo={jurisdictionInfo.PA} upgradeText={[]} />;
}

export default PennsylvaniaUpgrade;
